// 店舗ページの別店舗リンクのクリック計測
const LINK_SELECTOR = '.js-click-nearby-shop'

export const clickNearbyShop = (): void => {
  const links = document.querySelectorAll<HTMLElement>(LINK_SELECTOR)
  links.forEach((link) => {
    link.addEventListener('click', () => {
      window.gtag?.('event', 'click', { event_label: 'shop-nearby-shops' })
    })
  })
}
